export default __webpack_public_path__ + "static/media/template_1.f82997d6.png";